import React from "react";

export const GrainOverlay = () => (
  <div className="grain-overlay" aria-hidden="true" data-testid="grain-overlay" />
);
